import axios from "axios";
import { useEffect, useState } from "react";
import ApiUrl from "../Environment/ApiUrl";
import "../../assets/css/Loader.css";
import { useToast } from "../Toast/ToastContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function ChitCreation() {
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedChitId, setSelectedChitId] = useState(null);
  const [responseData, setResponseData] = useState([]);
  const [generateNumber, setGenerateNumber] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [getDeleteId, setDeleteId] = useState("");
  const [getDeleteName, setDeleteName] = useState("");
  const [addData, setAddData] = useState({
    chit_no: "",
    chit_name: "",
    date: getCurrentDate(),
    amount: "",
    status: "",
    created_by: "system",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateData, setUpdateData] = useState({
    id: "",
    chit_no: "",
    chit_name: "",
    date: "",
    amount: "",
    status: "",
    created_by: "system",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  // Modal functions
  const openModal = () => {
    setShowModal(true);
    fetchDataGenerate();
  };
  const closeModal = () => {
    setShowModal(false);
    setAddData({
      chit_no: "",
      chit_name: "",
      date: getCurrentDate(),
      amount: "",
      status: "",
      created_by: "system",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setGenerateNumber("");
    setValidationErrors({});
    setActionType("");
  };
  const closeUpdateModal = () => {
    setUpdateModal(false);
    setUpdateData({
      id: "",
      chit_no: "",
      chit_name: "",
      date: "",
      amount: "",
      status: "",
      created_by: "system",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setValidationErrors({});
  };
  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setDeleteId("");
    setDeleteName("");
  };

  // Notification functions
  const openNotificationModal = (id, action) => {
    setSelectedChitId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeNotificationModal = () => {
    setShowModal(false);
    setSelectedChitId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
      toast.error("Failed to fetch notifications", 3000, "topRight");
    }
  };

  const checkNotificationStatus = (chitId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === chitId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const hasPendingNotification = (chitId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === chitId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedChitId, actionType)) {
      toast.warning(
        "A pending request for this action already exists!",
        3000,
        "topRight"
      );
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "chit",
        table_id: selectedChitId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight"
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        "Error submitting notification. Please try again.",
        3000,
        "topRight"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Data fetching
  const fetchData = async () => {
    try {
      // setLoading(true);
      const localRole = localStorage.getItem("role");
      const localUsername = localStorage.getItem("username");
      const response = await axios.get(
        localRole === "Employee"
          ? `${ApiUrl}/Api/chit.php?employee_id=${localUsername}`
          : `${ApiUrl}/Api/chit.php`
      );
      const reversedData = (response.data?.data || []).reverse();

      setResponseData(reversedData);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
    } finally {
      // setTimeout(() => setLoading(false), 1000);
    }
  };

  const fetchDataGenerate = async () => {
    try {
      const response = await axios.get(
        `${ApiUrl}/Api/chit.php/generate-chit-code`
      );
      const chitNo = response.data?.chit_no || "";
      setGenerateNumber(chitNo);
      setAddData((prev) => ({ ...prev, chit_no: chitNo }));
    } catch (error) {
      console.error("Error fetching chit number:", error.message);
      setGenerateNumber("");
      toast.error("Failed to generate chit number", 3000, "topRight");
    }
  };

  // Date formatting
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const day = String(today.getDate()).toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Form validation
  const validateForm = (data) => {
    const errors = {};
    if (!data.chit_name) errors.chit_name = "Chit name is required";
    if (!data.amount) {
      errors.amount = "Amount is required";
    } else if (!/^\d+(\.\d{1,2})?$/.test(data.amount)) {
      errors.amount =
        "Amount must be a valid number with up to 2 decimal places";
    }
    if (!data.date) errors.date = "Creation date is required";
    if (!data.status || data.status === "Select Status") {
      errors.status = "Status is required";
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Add chit
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (!validateForm(addData)) return;

    try {
      setLoading(true);
      const formData = {
        ...addData,
        chit_no: generateNumber,
        created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };
      await axios.post(`${ApiUrl}/Api/chit.php`, formData);
      toast.success("Chit added successfully!", 3000, "topRight");
      closeModal();
      fetchData();
    } catch (error) {
      console.error("Error adding chit:", error.message);
      toast.error("Failed to add chit", 3000, "topRight");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  // Update chit
  const handleUpdate = (id, data) => {
    const userRole = localStorage.getItem("role");

    // if (userRole === "Employee") {
    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Edit")) {
        setUpdateId(id);
        setUpdateData({
          id,
          chit_no: data.chit_no || "",
          chit_name: data.chit_name || "",
          date: data.date || "",
          amount: data.amount || "",
          status: data.status || "",
          created_by: data.created_by || "system",
          created_date: data.created_date || "",
          updated_by: "system",
          updated_date: "",
        });
        setUpdateModal(true);
      } else {
        openNotificationModal(id, "Edit");
      }
    } else {
      setUpdateId(id);
      setUpdateData({
        id,
        chit_no: data.chit_no || "",
        chit_name: data.chit_name || "",
        date: data.date || "",
        amount: data.amount || "",
        status: data.status || "",
        created_by: data.created_by || "system",
        created_date: data.created_date || "",
        updated_by: "system",
        updated_date: "",
      });
      setUpdateModal(true);
    }
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    if (!validateForm(updateData)) return;

    try {
      setLoading(true);
      const formData = {
        ...updateData,
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };
      await axios.put(`${ApiUrl}/Api/chit.php/${updateId}`, formData);

      const notification = notifications.find(
        (notif) =>
          notif.table_id === updateId.toString() &&
          notif.button_value === "Edit" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Chit updated successfully!", 3000, "topRight");
      closeUpdateModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error updating chit:", error.message);
      toast.error("Failed to update chit", 3000, "topRight");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  // Delete chit
  const handleOpenModal = (id, chit_no) => {
    const userRole = localStorage.getItem("role");

    // if (userRole === "Employee") {
    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Delete")) {
        setDeleteId(id);
        setDeleteName(chit_no);
        setDeleteShowModals(true);
      } else {
        openNotificationModal(id, "Delete");
      }
    } else {
      setDeleteId(id);
      setDeleteName(chit_no);
      setDeleteShowModals(true);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(`${ApiUrl}/Api/chit.php/${getDeleteId}`);

      const notification = notifications.find(
        (notif) =>
          notif.table_id === getDeleteId.toString() &&
          notif.button_value === "Delete" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Chit deleted successfully!", 3000, "topRight");
      handleCloseModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting chit:", error.message);
      toast.error("Failed to delete chit", 3000, "topRight");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  // Pagination logic
  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.chit_no && item.chit_no.toLowerCase().includes(searchLower)) ||
      (item.chit_name && item.chit_name.toLowerCase().includes(searchLower)) ||
      (item.amount &&
        item.amount.toString().toLowerCase().includes(searchLower)) ||
      (item.status && item.status.toLowerCase().includes(searchLower))
    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // Export functions
  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
        <head>
          <title>Chit Creation Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .header { text-align: center; margin-bottom: 20px; }
            .badge { padding: 2px 6px; border-radius: 3px; font-size: 12px; }
            .badge.active { background-color: #28a745; color: white; }
            .badge.inactive { background-color: #dc3545; color: white; }
            .badge.default { background-color: #6c757d; color: white; }
            .table-secondary { background-color: #e2e3e5; }
            .table-danger { background-color: #f8d7da; }
            .table-info { background-color: #cff4fc; }
          </style>
        </head>
        <body>
          <div class="header"><h2>Chit Creation Report</h2></div>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Chit ID</th>
                <th>Chit Name</th>
                <th>Amount</th>
                <th>Creation Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
                .map((item, index) => {
                  const userId = localStorage.getItem("username");
                  const notification = notifications.find(
                    (notif) =>
                      notif.table_id === item.id.toString() &&
                      notif.employe_id === userId &&
                      notif.viewed === "false"
                  );
                  let rowClass = "";
                  if (notification) {
                    switch (notification.status) {
                      case "accepted":
                        rowClass = "table-secondary";
                        break;
                      case "rejected":
                        rowClass = "table-danger";
                        break;
                      case "requested":
                        rowClass = "table-info";
                        break;
                    }
                  }
                  const statusClass =
                    item.status === "Active"
                      ? "active"
                      : item.status === "Inactive"
                      ? "inactive"
                      : "default";
                  return `
                    <tr class="${rowClass}">
                      <td>${index + 1}</td>
                      <td>${item.chit_no || ""}</td>
                      <td>${item.chit_name || ""}</td>
                      <td>₹${item.amount || "0"}</td>
                      <td>${formatDate(item.date)}</td>
                      <td><span class="badge ${statusClass}">${
                    item.status || ""
                  }</span></td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(20);
      doc.text("Chit Creation Report", 14, 22);
      doc.setFontSize(12);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

      const tableColumn = [
        "S.No",
        "Chit ID",
        "Chit Name",
        "Amount",
        "Creation Date",
        "Status",
      ];
      const tableRows = filteredData.map((item, index) => {
        const userId = localStorage.getItem("username");
        const notification = notifications.find(
          (notif) =>
            notif.table_id === item.id.toString() &&
            notif.employe_id === userId &&
            notif.viewed === "false"
        );
        let rowStyle = "";
        if (notification) {
          switch (notification.status) {
            case "accepted":
              rowStyle = { fillColor: [226, 227, 229] };
              break;
            case "rejected":
              rowStyle = { fillColor: [248, 215, 218] };
              break;
            case "requested":
              rowStyle = { fillColor: [207, 244, 252] };
              break;
          }
        }
        return [
          index + 1,
          item.chit_no || "",
          item.chit_name || "",
          `₹${item.amount || "0"}`,
          formatDate(item.date),
          item.status || "",
          rowStyle,
        ];
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows.map((row) => row.slice(0, -1)),
        startY: 45,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 25 },
          2: { cellWidth: 40 },
          3: { cellWidth: 25 },
          4: { cellWidth: 30 },
          5: { cellWidth: 20 },
        },
        didParseCell: (data) => {
          if (data.section === "body") {
            const rowIndex = data.row.index;
            const rowStyle =
              tableRows[rowIndex][tableRows[rowIndex].length - 1];
            if (rowStyle) {
              data.cell.styles = { ...data.cell.styles, ...rowStyle };
            }
          }
        },
      });

      doc.save("chit-creation-report.pdf");
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers = [
        "S.No",
        "Chit ID",
        "Chit Name",
        "Amount",
        "Creation Date",
        "Status",
      ];
      const rows = filteredData.map((item, index) => [
        index + 1,
        item.chit_no || "",
        item.chit_name || "",
        item.amount || "0",
        formatDate(item.date),
        item.status || "",
      ]);

      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(formattedText)
          .then(() => {
            toast.success(
              "Data copied to clipboard successfully!",
              3000,
              "topRight"
            );
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(formattedText);
          });
      } else {
        fallbackCopy(formattedText);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Error copying data. Please try again.", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Data copied to clipboard!", 3000, "topRight");
      } else {
        toast.error("Failed to copy data", 3000, "topRight");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const csvData = [
        ["S.No", "Chit ID", "Chit Name", "Amount", "Creation Date", "Status"],
        ...filteredData.map((item, index) => [
          index + 1,
          item.chit_no || "",
          item.chit_name || "",
          item.amount || "0",
          formatDate(item.date),
          item.status || "",
        ]),
      ];

      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chit-creation-report.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        "Chit ID": item.chit_no || "",
        "Chit Name": item.chit_name || "",
        Amount: item.amount || "0",
        "Creation Date": formatDate(item.date),
        Status: item.status || "",
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const colWidths = [
        { wch: 8 },
        { wch: 15 },
        { wch: 25 },
        { wch: 15 },
        { wch: 18 },
        { wch: 12 },
      ];
      ws["!cols"] = colWidths;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Chit Creation");
      XLSX.writeFile(wb, "chit-creation-report.xlsx");
      toast.success("Excel file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
    }
  };

  // Periodic data fetch
  useEffect(() => {
    fetchData();
    fetchNotifications();
    const interval = setInterval(() => {
      fetchData();
      fetchNotifications();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )} */}
      <div className="container-fluid py-3">
        <div className="d-flex mb-4">
          <h6 className="card-title m-2">Chit Creation</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={openModal}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex">
                <label className="d-flexform-label text-dark mt-2">Show :</label>
                <div>
                  <select
                  className="form-control mx-2"
                  onChange={handleItemsPerPageChange}
                  value={showAllItems ? "All" : itemsPerPage}
                >
                  <option value="All">All</option>
                  {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>
              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card tableCard p-2">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th>S.No</th>
                      <th>Chit ID</th>
                      <th>Chit Name</th>
                      <th>Amount</th>
                      <th>Creation Date</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(currentItems) && currentItems.length > 0 ? (
                      currentItems.map((item, index) => {
                        const userId = localStorage.getItem("username");
                        const notification = notifications.find(
                          (notif) =>
                            notif.table_id === item.id.toString() &&
                            notif.viewed === "false"
                        );
                        let rowClass = "";
                        if (notification) {
                          switch (notification.status) {
                            case "accepted":
                              rowClass = "table-secondary";
                              break;
                            case "rejected":
                              rowClass = "table-danger";
                              break;
                            case "requested":
                              rowClass = "table-info";
                              break;
                          }
                        }
                        return (
                          <tr key={item.id} className={rowClass}>
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>{item.chit_no}</td>
                            <td>{item.chit_name}</td>
                            <td>₹{item.amount}</td>
                            <td>{formatDate(item.date)}</td>
                            <td>
                              {item.status === "Active" ? (
                                <span className="badge bg-success text-white">
                                  Active
                                </span>
                              ) : item.status === "Inactive" ? (
                                <span className="badge bg-danger text-white">
                                  Inactive
                                </span>
                              ) : (
                                <span className="badge bg-secondary text-white">
                                  {item.status}
                                </span>
                              )}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() => handleUpdate(item.id, item)}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={() =>
                                  handleOpenModal(item.id, item.chit_no)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No chits found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">««</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">«</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">»</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">»»</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addChitModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title text-primary" id="addChitModalLabel">
                {actionType
                  ? `Send ${actionType} Request to Admin`
                  : "Add Chit"}
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={actionType ? closeNotificationModal : closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {actionType ? (
                <form onSubmit={handleNotificationSubmit}>
                  <p className="text-center">
                    Do you want to request to {actionType.toLowerCase()} this
                    chit?
                  </p>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm px-4 me-2"
                      onClick={closeNotificationModal}
                    >
                      No
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                      disabled={isSubmitting}
                    >
                      Yes
                    </button>
                  </div>
                </form>
              ) : (
                <form onSubmit={handlesubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="chitNo" className="form-label">
                          Chit ID <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="chitNo"
                          value={generateNumber}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="chitName" className="form-label">
                          Chit Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            validationErrors.chit_name ? "is-invalid" : ""
                          }`}
                          id="chitName"
                          placeholder="Enter Chit Name"
                          value={addData.chit_name}
                          onChange={(e) =>
                            setAddData({
                              ...addData,
                              chit_name: e.target.value,
                            })
                          }
                          required
                        />
                        {validationErrors.chit_name && (
                          <div className="invalid-feedback">
                            {validationErrors.chit_name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="amount" className="form-label">
                          Amount <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            validationErrors.amount ? "is-invalid" : ""
                          }`}
                          id="amount"
                          placeholder="Enter Amount"
                          value={addData.amount}
                          onChange={(e) =>
                            setAddData({ ...addData, amount: e.target.value })
                          }
                          required
                        />
                        {validationErrors.amount && (
                          <div className="invalid-feedback">
                            {validationErrors.amount}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="creationDate" className="form-label">
                          Creation Date <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            validationErrors.date ? "is-invalid" : ""
                          }`}
                          id="creationDate"
                          value={addData.date}
                          onChange={(e) =>
                            setAddData({ ...addData, date: e.target.value })
                          }
                          required
                        />
                        {validationErrors.date && (
                          <div className="invalid-feedback">
                            {validationErrors.date}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="status" className="form-label">
                      Status <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select ${
                        validationErrors.status ? "is-invalid" : ""
                      }`}
                      id="status"
                      value={addData.status}
                      onChange={(e) =>
                        setAddData({ ...addData, status: e.target.value })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select Status
                      </option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    {validationErrors.status && (
                      <div className="invalid-feedback">
                        {validationErrors.status}
                      </div>
                    )}
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{
          display: updateModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="updateChitModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="updateChitModalLabel"
              >
                Update Chit
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeUpdateModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleupdatesubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateChitNo" className="form-label">
                        Chit ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="updateChitNo"
                        value={updateData.chit_no}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateChitName" className="form-label">
                        Chit Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          validationErrors.chit_name ? "is-invalid" : ""
                        }`}
                        id="updateChitName"
                        placeholder="Enter Chit Name"
                        value={updateData.chit_name}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            chit_name: e.target.value,
                          })
                        }
                        required
                      />
                      {validationErrors.chit_name && (
                        <div className="invalid-feedback">
                          {validationErrors.chit_name}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="updateAmount" className="form-label">
                        Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          validationErrors.amount ? "is-invalid" : ""
                        }`}
                        id="updateAmount"
                        placeholder="Enter Amount"
                        value={updateData.amount}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            amount: e.target.value,
                          })
                        }
                        required
                      />
                      {validationErrors.amount && (
                        <div className="invalid-feedback">
                          {validationErrors.amount}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label
                        htmlFor="updateCreationDate"
                        className="form-label"
                      >
                        Creation Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className={`form-control ${
                          validationErrors.date ? "is-invalid" : ""
                        }`}
                        id="updateCreationDate"
                        value={updateData.date}
                        onChange={(e) =>
                          setUpdateData({ ...updateData, date: e.target.value })
                        }
                        required
                      />
                      {validationErrors.date && (
                        <div className="invalid-feedback">
                          {validationErrors.date}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="updateStatus" className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      validationErrors.status ? "is-invalid" : ""
                    }`}
                    id="updateStatus"
                    value={updateData.status}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, status: e.target.value })
                    }
                    required
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {validationErrors.status && (
                    <div className="invalid-feedback">
                      {validationErrors.status}
                    </div>
                  )}
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-primary btn-sm px-4">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "80px", margin: "0 auto" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you really want to delete this
                <span className="text-primary">({getDeleteName})</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(showModal || updateModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}
export default ChitCreation;
